import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';
import { type Registry as Services } from '@ember/service';

export const useRouter = (): Services['router'] => {
  // eslint-disable-next-line @repo/no-use-ember-service-router -- Hook provides router access for React components
  return useEmberService('router');
};
